




































































































import Component from 'vue-class-component'
import { EFacilityBlockableFeatures, EUserStatus, IResident } from '@zunta/configurations'
import Tabs from '@/components/layout/Tabs.vue'
import Switcher from '@/components/Switcher.vue'
import Icon from '@/components/Icon.vue'
import Select from '@/components/Select.vue'
import DateInput from '@/components/inputs/DateInput.vue'
import Contact from './components/Contact.vue'
import ScrollView from '@/components/ScrollView.vue'
import SearchInput from '@/components/inputs/SearchInput.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import TaskFinishedModal from './components/TaskFinishedModal.vue'
import CollectionSharedFunctions from '@/views/app/management/collections/CollectionSharedFunctions'
import CollectionActions from '@/views/app/management/collections/components/CollectionActions.vue'
import CollectionHistoryTable from '@/views/app/management/collections/components/CollectionHistoryTable.vue'
import CollectionResident from '@/views/app/management/collections/components/CollectionResident.vue'
import { Watch } from 'vue-property-decorator'
import Card from '@/components/Card.vue'
import CollectionResidentBalanceInfo
  from '@/views/app/management/collections/components/CollectionResidentBalanceInfo.vue'
import CollectionContacts from '@/views/app/management/collections/components/CollectionContacts.vue'
import CollectionAgingView from '@/views/app/management/collections/sections/CollectionAgingView.vue'
import Modal from '@/components/Modal.vue'
import ResidentAutoPayments from '@/views/app/management/residents/resident-page/components/ResidentAutoPayments.vue'
import ResidentPaymentHistory
  from '@/views/app/management/residents/resident-page/components/ResidentPaymentHistory.vue'
import GoBack from '@/components/GoBack.vue'
import { isFacilityFeatureBlocked } from '@/utils/facility/facilityFeatures'

const range = require('lodash.range')

@Component({
  components: {
    GoBack,
    ResidentPaymentHistory,
    ResidentAutoPayments,
    Modal,
    CollectionAgingView,
    CollectionContacts,
    CollectionResidentBalanceInfo,
    Card,
    CollectionResident,
    CollectionHistoryTable,
    CollectionActions,
    TaskFinishedModal,
    DateTimeLabel,
    SearchInput,
    Contact,
    DateInput,
    Select,
    Icon,
    Switcher,
    Tabs,
    ScrollView
  }
})
export default class CollectionView extends CollectionSharedFunctions {
  async mounted () {
    this.$eventBus.$emit('loading:enable', { message: 'Loading' })
    this.$store.state.resident.collectionTasks = []
    this.$store.state.resident.residentContacts = []
    this.$store.state.transactions.transactionIntervals = []
    this.$store.state.resident.openBalance = 0
    await this.residentModuleInstance.fetchCollectionTasksByFilters({
      type: this.type === 'today' ? 'today' : 'all',
      active: true
    })

    if (!this.residentId) {
      await this.$router.push({
        name: 'management-collection-resident',
        params: {
          residentId: (this.collectionTasks[0].resident as IResident).id.toString()
        },
        query: {
          type: this.type
        }
      })
    }
    await this.facilityModuleInstance.getFacility(this.selectedTask.facility.id)
    await this.userModuleInstance.getManagementUsersList({
      status: EUserStatus.ACTIVE
    })
    await this.templateModuleInstance.fetchTemplates({})
    if (this.collectionTasks.length === 0) {
      this.noResidentsInCollections = true
    }
    await this.updateResidentInfo()
    setTimeout(() => {
      this.$eventBus.$emit('loading:disable')
      if (this.type === 'today' && this.collectionTasks && !this.collectionTasks.length) {
        this.noTasksModal = true
      }
    }, 400)
  }

  @Watch('residentId')
  async watchResidentId () {
    this.$eventBus.$emit('loading:enable', { message: 'Loading' })
    await this.updateResidentInfo()
    setTimeout(() => {
      this.$eventBus.$emit('loading:disable')
    }, 400)
  }
}
